import { useQuery } from '@tanstack/react-query'
import axiosInstance from '@/core/api'

type PlayerResult = {
	id: string
	phone: string
	username: string | null
	accountNumber: string | null
	accountName: string | null
	bankProvider: string | null
}

export function useQuerySearchAllPlayers(search: string) {
	return useQuery({
		queryKey: ['search-all-players', search],
		queryFn: async () => {
			const { data } = await axiosInstance.get<{
				data: PlayerResult[]
			}>('/admin/bank-transactions/search-players', {
				params: { q: search },
			})
			return data.data ?? []
		},
		enabled: search.length >= 3,
		staleTime: 30_000,
	})
}
